// MIT License - Copyright (c) 2026 Doug McNall

export const MarvelAliensPlanets = {
  planets: {
    2100: ['spiderman', 'ironman', 'captainamerica', 'hulk', 'blackwidow', 'hawkeye'],
    2101: ['thor', 'loki', 'heimdall', 'valkyrie'],
    2102: ['nova', 'starlord', 'gamora', 'drax'],
    2103: ['rocket', 'groot', 'collector'],
    2104: ['thanos', 'nebula'],
    2105: ['hulk', 'valkyrie', 'korg'],
    2106: ['blackpanther', 'shuri', 'okoye'],
    2107: ['captainmarvel', 'ronan', 'yonrogg'],
    2108: ['talos', 'skrull'],
    2109: ['ego', 'mantis'],
    2110: ['redskull', 'gamora'],
    2111: ['eitri', 'thor']
  },
  randomEncounters: ['thanos', 'loki', 'ultron', 'ronan'],
  hostileSpecies: ['thanos', 'ultron', 'ronan', 'redskull', 'ego'],
  friendlyTraders: ['starlord', 'rocket', 'collector', 'nova']
};

export default MarvelAliensPlanets;
